import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-message-warning",
  "use": "rt-base-message-warning-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-message-warning\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z\" p-id=\"2454\" /><path d=\"M512 660m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z\" p-id=\"2455\" /><path d=\"M482 572h60c5.5 0 10-3.2 10-7.1V323.1c0-3.9-4.5-7.1-10-7.1h-60c-5.5 0-10 3.2-10 7.1v241.8c0 3.9 4.5 7.1 10 7.1z\" p-id=\"2456\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/message-warning.svg
// module id = 1766
// module chunks = 137